var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6479 0.914062C5.56994 0.914062 0.642822 5.84128 0.642822 11.9193C0.642822 17.9975 5.56994 22.9244 11.6479 22.9244C17.7261 22.9244 22.6532 17.9975 22.6532 11.9193C22.6533 5.84128 17.7262 0.914062 11.6479 0.914062ZM15.9199 17.2859H7.321L8.04374 13.8356L6.63843 14.7992L6.97981 12.9111L8.44964 11.8993L9.89142 5.01736H12.5758L11.5832 9.7428L15.0781 7.33749L14.6686 9.29392L11.1742 11.6894L10.4829 14.981H16.3975L15.9199 17.2859Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/ltc.9dcac91c730ab5b002e43c693f607f95.svg";
export { ForwardRef as ReactComponent };